module.exports = __webpack_public_path__ + "static/img/bg.dfb67f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/bg.png
// module id = lQR8
// module chunks = 2